import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";

// Header that carries the per-upload owner token (see startUpload). Sent on
// every mutating call so the server can verify the caller started this upload,
// in addition to the normal Bearer access token and chat-membership check.
const UPLOAD_TOKEN_HEADER = "X-Upload-Token";

export const startUpload = async (
  chatId: string,
  fileName: string,
  contentType: string,
  plainTextSize: number,
  chunkSize: number,
): Promise<{ uploadId: string; uploadToken: string }> => {
  const response = await requestApi({
    url: ApiEndpoints.CHUNKED_UPLOAD_START,
    method: "POST",
    data: { chatId, fileName, contentType, plainTextSize, chunkSize },
  });
  // `uploadToken` is an opaque, server-signed token — store and echo it back,
  // never parse it.
  return response.data;
};

export const uploadPart = async (
  uploadId: string,
  partNumber: number,
  chunk: Uint8Array,
  uploadToken: string,
  signal?: AbortSignal,
): Promise<{ partNumber: number }> => {
  const formData = new FormData();
  formData.append("uploadId", uploadId);
  formData.append("partNumber", String(partNumber));
  formData.append(
    "chunk",
    new Blob([chunk], { type: "application/octet-stream" }),
    "chunk",
  );

  const response = await requestApi({
    url: ApiEndpoints.CHUNKED_UPLOAD_PART,
    method: "POST",
    data: formData,
    headers: { [UPLOAD_TOKEN_HEADER]: uploadToken },
    signal,
  });
  return response.data;
};

export const completeUpload = async (
  uploadId: string,
  parts: { PartNumber: number }[],
  uploadToken: string,
): Promise<{ location: string }> => {
  const response = await requestApi({
    url: ApiEndpoints.CHUNKED_UPLOAD_COMPLETE,
    method: "POST",
    data: { uploadId, parts },
    headers: { [UPLOAD_TOKEN_HEADER]: uploadToken },
  });
  return response.data;
};

export const abortUpload = async (
  uploadId: string,
  uploadToken: string,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.CHUNKED_UPLOAD_ABORT,
    method: "POST",
    data: { uploadId },
    headers: { [UPLOAD_TOKEN_HEADER]: uploadToken },
  });
};
